/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { ViewChild } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QuickCallDetailService } from '../service/quickcalldetail.service';
import { QuickCallDetailInfo, GroupTemplateReqParameters, GroupTemplateQuickCallInfos } from '../model/quickcallresponse';
import { BehaviorSubject, Subject } from 'rxjs';
import { ItemSearch, Classification } from '../../../shared/model/itemselectionresponse';
import { ItemSelectionService } from '../../../shared/services/itemselection.service';
import { ReportIncidentService } from '../../reportincident/services/reportincident.service';
import { CustomerPreferenceService } from '../../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../../preference/customerpreference.model';
import { CustomField } from '../../../shared/model/customfieldsresponse';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { RequestResponse, CustomFieldRequest, IncidentFileUpload } from '../../reportincident/model/reportincident.response';
import { CreatedRequestResponse } from '../../reportincident/model/createdrequestresponse';
import { AlertMessage } from '../../../../../shared/alert/alertmessage';
import { AlertService } from '../../../../../shared/alert/alert.service';
import { ZsdFormIOComponent } from '../zsdformio/zsdformio.component';
import { QuickcallFieldsComponent } from './quickcallfields.component';
import { PlatformLocation } from '@angular/common';
import { ZSDTranslateService } from '../../../../../common/zsd-translate.service';
import { FileUploadStatus } from '../../../store/model/fileuploadstatus';
import { debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';
import 'rxjs/add/operator/debounceTime';
declare var $: any;
@Component({
  selector: 'zsd-quickcalldetail',
  templateUrl: '../view/quickcalldetail.component.html',
  styleUrls: ['../view/quickcalldetail.component.scss']

})

export class QuickCallDetailComponent implements OnInit {
  quickCallForm: FormGroup;
  quickCallIdNumber;
  quickCallTypeName;
  quickCallProcessIndexName;
  quickCallRequest: RequestResponse = new RequestResponse();
  groupQuickCallRequest: GroupTemplateReqParameters = new GroupTemplateReqParameters();
  createdRequestResponse: CreatedRequestResponse = new CreatedRequestResponse();
  serverError = null;
  itemId;
  itemName: string;
  itemIdentifier: string;
  itemTypeName: string;
  classificationName: string;
  priorityName: string;
  itemTypeId: number;
  statusName: string;
  subject = '';
  quickCallDetail: QuickCallDetailInfo = new QuickCallDetailInfo();
  quickCallListForGroup: (QuickCallDetailInfo)[] | null;
  itemInfo: ItemSearch;
  tempCustomFields: (CustomField)[] | null;
  customFields: (CustomField)[] | null;
  public validFileList: Array<File> = [];
  incidentFileUpload: IncidentFileUpload = new IncidentFileUpload();
  fileUploadForm: boolean;
  processIndexString;
  selectedName;
  itemSearchTerm = '';
  selectedClassification;
  classificationOptions = new Array<Classification>();
  defaultItemNameString = '';
  loading = false;
  subjectFieldFocus = false;
  showSubject: boolean;
  subjectRequired = false;
  itemSelectionRequired;
  showStatus = false;
  requestNumbers = [];
  oneQuickcallSelected = false;
  tableContainErrors = false;
  formSchema = new Array();

  itemSearch = new FormControl();

  itemCategories: ItemSearch[] = [];
  selectedItemName: string;
  private itemSubject: Subject<ItemSearch[]> = new Subject();
  itemResultFromSearch: ItemSearch[] = [];

  itemSelected: number;
  showdropDownList = true;
  flagItemNotFound = false;

  @Output() private clearForm: EventEmitter<boolean> = new EventEmitter();
  private _quickCallId: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  private _quickCallType: BehaviorSubject<string> = new BehaviorSubject<string>(null);


  @Input() set quickCallType(value: string) {
    this._quickCallType.next(value);
  }
  @Input() set quickCallId(value: number) {
    this._quickCallId.next(value);
  }

  get quickCallId() {
    return this._quickCallId.getValue();
  }
  get quickCallType() {
    return this._quickCallType.getValue();
  }
  @ViewChild(ZsdFormIOComponent, { static: false }) formio;
  @ViewChild(QuickcallFieldsComponent, { static: false }) formioGroup;

  constructor(private quickcallDetailService: QuickCallDetailService, public itemSelectionservice: ItemSelectionService,
    public reportIncidentService: ReportIncidentService, public formBuilder: FormBuilder, public alertService: AlertService,
    public customerPreferenceService: CustomerPreferenceService, location: PlatformLocation,
    public zsdTranslate: ZSDTranslateService) {
    this.selectedName = this.defaultItemNameString;
    location.onPopState(() => {
      $('#zsd_modal_quickcall_detail').modal('hide');
    });
  }

  ngOnInit() {
    this._quickCallId.subscribe(() => {
      this.quickCallIdNumber = this.quickCallId;
    });
    this._quickCallType.subscribe(() => {
      this.quickCallTypeName = this.quickCallType;
    });

    if (this.quickCallTypeName === 'Quick Call') {
      this.quickCallTypeName = 'quickCall';
    } else if (this.quickCallTypeName === 'Group Quick Call') {
      this.quickCallTypeName = 'groupQuickCall';
    }

    this.selectedName = this.defaultItemNameString;
    this.tempCustomFields = null;

    if (this.quickCallTypeName === 'quickCall') {
      this.quickCallForm = this.formBuilder.group({
        item: this.formBuilder.control({ value: null }),
        classification: this.formBuilder.control({ value: null }),
        subject: this.formBuilder.control({ value: '' })
      });
    } else {
      this.quickCallForm = this.formBuilder.group({
      });
    }

    // for item search
    this.itemSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((searchTerm) => (searchTerm.length > 1)),
      switchMap(searchTerm => this.itemSelectionservice.getItemSearch(this.quickCallDetail.requestProcess, searchTerm))
      ).subscribe((resp: ItemSearch[]) => {
          let responseItemSearchFlag = false;
          if (resp.length > 0) {
            responseItemSearchFlag = true;
          }
          if (responseItemSearchFlag) {
            this.flagItemNotFound = false;
            this.showdropDownList = true;
            this.itemResultFromSearch = resp;
          } else {
            this.showdropDownList = false;
            this.flagItemNotFound = true;
            this.itemResultFromSearch = null;
          }
        }
    );

    // preferences
    this.customerPreferenceService.getPreferenceList().subscribe(
      (preferences: CustomerPreferenceResponse) => {
        this.showSubject = preferences.showSubject;
        this.subjectRequired = preferences.subjectRequired;
        this.showStatus = preferences.showStatusField;
        if (this.quickCallTypeName === 'quickCall') {
          if (this.subjectRequired) {
            this.quickCallForm.get('subject').setValidators(Validators.required);
          }
          this.quickCallForm.get('subject').setValue(this.subject);
        }
      },
      err => console.error(err)
    );

    this.quickcallDetailService.getQuickCallDetail(this.quickCallIdNumber, this.quickCallTypeName).subscribe(
      (quickCallDetailInfoResponse: QuickCallDetailInfo) => {
        this.quickCallDetail = quickCallDetailInfoResponse;
        if (quickCallDetailInfoResponse.quickCallType === 'quickCall') {
          if (quickCallDetailInfoResponse.itemSpecified) {
            this.itemName = quickCallDetailInfoResponse.itemInfo.itemName;
            this.itemIdentifier = quickCallDetailInfoResponse.itemInfo.itemIdentifier;
            this.itemTypeName = quickCallDetailInfoResponse.itemInfo.itemTypeName;
            this.statusName = quickCallDetailInfoResponse.itemInfo.statusName;
            this.classificationName = quickCallDetailInfoResponse.classification.classificationName;
          } else {
            this.itemSelectionRequired = true;
            this.selectedName = this.defaultItemNameString;
            this.itemInfo = this.quickCallDetail.itemInfo;
          }
          if (quickCallDetailInfoResponse.containCustomForm) {
            this.formSchema = JSON.parse(quickCallDetailInfoResponse.formSchema);
          }
          this.subject = this.quickCallDetail.subject;

        } else if (quickCallDetailInfoResponse.quickCallType === 'groupQuickCall') {
          if (quickCallDetailInfoResponse.itemInfo.itemTypeId !== -1) {
            this.itemTypeName = quickCallDetailInfoResponse.itemInfo.itemTypeName;
            this.classificationName = quickCallDetailInfoResponse.classification.classificationName;
          }
          this.statusName = quickCallDetailInfoResponse.itemInfo.statusName;
          this.quickCallListForGroup = quickCallDetailInfoResponse.quickCallList;
          for (let i = 0; i < this.quickCallListForGroup.length; i++) {
            this.quickCallListForGroup[i].containCustom = false;
            this.quickCallListForGroup[i].isMandatoryCustomField = false;
            this.quickCallListForGroup[i].selected = true;
            for (let j = 0; j < this.quickCallListForGroup[i].customFieldInfo.length; j++) {
              this.quickCallListForGroup[i].containCustom = true;
              if (this.quickCallListForGroup[i].customFieldInfo[j].required) {
                this.quickCallListForGroup[i].isMandatoryCustomField = true;
                break;
              }
            }
            if (this.quickCallListForGroup[i].containCustomForm) {
              this.quickCallListForGroup[i].parsedFormData = JSON.parse(this.quickCallListForGroup[i].formSchema);
              for (let k = 0; k < this.quickCallListForGroup[i].parsedFormData.components.length; k++) {
                if (!this.quickCallListForGroup[i].isMandatoryCustomField &&
                  this.quickCallListForGroup[i].parsedFormData.components[k].validate &&
                  this.quickCallListForGroup[i].parsedFormData.components[k].validate.required) {
                  this.quickCallListForGroup[i].isMandatoryCustomField = true;
                  break;
                }
              }
            }
          }
        }
        this.priorityName = quickCallDetailInfoResponse.priority.displayName;
        this.customFields = quickCallDetailInfoResponse.customFieldInfo;
      });
  }


  searchItem(event: any) {
    this.showdropDownList = true;
    let selectedItemName = event.target.value;
    if (selectedItemName == null) {
      this.flagItemNotFound = true;
    }
    this.itemSubject.next(selectedItemName);
    this.flagItemNotFound = false;
    $('.searchList').css('border', '1px solid #ced4da');
    $('.searchList').css('border-top', 'none');

  }

  setItem(selectedItemFromSearch: ItemSearch) {
    this.itemResultFromSearch = null;
    this.selectedItemName = null;
    this.selectedName = selectedItemFromSearch.itemId;
    if (this.selectedName !== this.defaultItemNameString) {
      this.selectedName = selectedItemFromSearch.itemId;
      this.itemSearchTerm = '';
      this.itemName = selectedItemFromSearch.itemName;
      this.itemIdentifier = selectedItemFromSearch.itemIdentifier;
      this.statusName = selectedItemFromSearch.statusName;
      this.itemTypeName = selectedItemFromSearch.itemTypeName;
      this.itemTypeId = selectedItemFromSearch.itemTypeId;

      let tempCustomFields1: (CustomField)[] | null;
      tempCustomFields1 = this.tempCustomFields;

      let customFields1: (CustomField)[] | null;
      customFields1 = this.customFields;

      this.itemSelectionservice.getClassification(this.itemTypeId).subscribe(
        (classification: Classification[]) => {
          this.classificationOptions = classification;
          for (let i = 0; i < this.classificationOptions.length; i++) {
            if (this.classificationOptions[i].isDefault) {
              this.selectedClassification = this.classificationOptions[i].classificationId;
            }
          }
        },
        err => console.error(err)
      );

      this.reportIncidentService.getCustomFields(this.itemTypeId, 'itemtype').subscribe(
        (customFieldResponse: CustomField[]) => {
          let tempFields: (CustomField)[] | null;
          tempFields = [];
          if (tempCustomFields1 !== null) {
            for (let i = 0; i < customFields1.length; i++) {
              let found = true;
              for (let j = 0; j < tempCustomFields1.length; j++) {
                if (this.tempCustomFields[j].fieldId === this.customFields[i].fieldId) {
                  found = false;
                  break;
                }
              }
              if (found) {
                tempFields.push(this.customFields[i]);
              }
            }
            customFields1 = tempFields;
          }
          customFields1 = customFields1.concat(customFieldResponse);
          tempCustomFields1 = customFieldResponse;
          this.customFields = customFields1;
          this.tempCustomFields = tempCustomFields1;
        },
        err => console.error(err)
      );

    } else {
      let tempFields: (CustomField)[] | null;
      tempFields = [];
      if (this.tempCustomFields !== null) {
        for (let i = 0; i < this.customFields.length; i++) {
          let custom: CustomField = this.customFields[i];
          let found = true;
          for (let j = 0; j < this.tempCustomFields.length; j++) {
            let tempCustom: CustomField = this.tempCustomFields[j];
            if (tempCustom.fieldId === custom.fieldId) {
              found = false;
              break;
            }
          }
          if (found) {
            tempFields.push(custom);
          }
        }
        this.customFields = tempFields;
        this.tempCustomFields = null;
      }

    }

    this.currentSearchItemIndex = -1;
  }

  cancelQuickCall() {
    this.clearForm.emit(true);
  }

  isfileuploadformvalid(formvalid: boolean) {
    this.fileUploadForm = formvalid;
  }

  selectedFilesList(fileList: Array<File>) {
    const newFileList = [];
    for (let i = 0; i < fileList.length; i++) {
      newFileList.push(fileList[i]);
    }
    this.validFileList = newFileList;
  }

  trackByCatOptions(index) {
    return index;
  }

  trackByTypeOptions(index) {
    return index;
  }

  trackByNameOptions(index) {
    return index;
  }

  subjectEmpty() {
    if (this.subject) {
      return false;
    } else {
      return true;
    }
  }

  callFormioSubmitButton() {
    if (this.quickCallTypeName === 'quickCall' && this.quickCallDetail.containCustomForm) {
      this.formio.checkSubmit();
    }
    if (this.quickCallTypeName === 'groupQuickCall') {
      let quickCallListId = new Array<number>();
      for (let i = 0; i < this.quickCallListForGroup.length; i++) {
        let quickcallId = this.quickCallListForGroup[i].id;
        if (this.quickCallDetail.groupComponentsSelection) {
          if (this.quickCallListForGroup[i].selected && this.quickCallListForGroup[i].containCustomForm) {
            quickCallListId.push(quickcallId);
          }
        } else {
          if (this.quickCallListForGroup[i].containCustomForm) {
            quickCallListId.push(quickcallId);
          }
        }
      }
      if (quickCallListId.length > 0) {
        this.formioGroup.checkSubmit(quickCallListId);
      }
    }
  }

  checkForcustomformValidation(): boolean {
    let formValid = true;
    if (this.quickCallDetail.containCustomForm && !this.quickCallForm.value.customform.formiovalid) {
      formValid = false;
    }
    return formValid;
  }


  checkForcustomformValidationForGroup(): boolean {
    let formValid = true;
    let quickCallListWithInValidCustomFrom = new Array<number>();
    for (let i = 0; i < this.quickCallListForGroup.length; i++) {
      let quickcallId = this.quickCallListForGroup[i].id;
      if (this.quickCallDetail.groupComponentsSelection) {
        if (this.quickCallListForGroup[i].selected && this.quickCallListForGroup[i].containCustomForm &&
          !(((this.quickCallForm.controls['qc' + quickcallId] as FormGroup)
            .controls['customform'] as FormGroup).controls['formiovalid'].value)) {
          quickCallListWithInValidCustomFrom.push(quickcallId);
        }
      } else {
        if (this.quickCallListForGroup[i].containCustomForm &&
          !(((this.quickCallForm.controls['qc' + quickcallId] as FormGroup)
            .controls['customform'] as FormGroup).controls['formiovalid'].value)) {
          quickCallListWithInValidCustomFrom.push(quickcallId);
        }
      }
    }
    if (quickCallListWithInValidCustomFrom.length > 0) {
      formValid = false;
    }
    return formValid;
  }


  createRequest() {
    this.quickCallRequest = new RequestResponse();
    this.serverError = null;
    if (this.quickCallTypeName === 'quickCall') {
      if (this.itemSelectionRequired && this.selectedName === this.defaultItemNameString) {
        this.quickCallForm.controls['item'].setErrors({ 'invalid': true });
      }
      if (this.quickCallForm.valid && this.fileUploadForm && this.checkForcustomformValidation()) {
        // item id
        this.loading = true;
        if (this.quickCallDetail.itemSpecified) {
          this.quickCallRequest.itemId = this.quickCallDetail.itemInfo.itemId;
          this.quickCallRequest.classfication = this.quickCallDetail.classification.classificationId;
        } else {
          if (this.selectedName === -1 || this.selectedName === null) {
            this.quickCallRequest.itemId = null;
          } else {
            this.quickCallRequest.itemId = this.selectedName;
          }
          this.quickCallRequest.classfication = this.selectedClassification;
        }

        // priority
        this.quickCallRequest.requestPriority = this.quickCallDetail.priority.requestPriorityId;

        // subject
        this.quickCallRequest.subject = this.subject;

        // description
        this.quickCallRequest.requestDescription = this.quickCallForm.value.tinyMce.tinymce;

        // customForm
        if (this.quickCallDetail.containCustomForm) {
          let formData: string;
          if (this.quickCallForm.value.customform.formioform.hasOwnProperty('components')) {
            formData = this.getCustomFormData(this.quickCallForm.value.customform.formioform);
          } else {
            formData = JSON.stringify(this.quickCallForm.value.customform.formioform);
          }
          this.quickCallRequest.formSubmission = formData;
        }


        // custom fields
        for (let i = 0; i < this.customFields.length; i++) {
          let customField: CustomField = this.customFields[i];
          if (!this.quickCallRequest.customFields) {
            this.quickCallRequest.customFields = new Array<CustomFieldRequest>();
          }
          if (customField.clientEditable !== 0) {
            let customfieldRequest: CustomFieldRequest = new CustomFieldRequest();
            customfieldRequest.fieldId = customField.fieldId;
            if (customField.dataType === 4) { // Currency
              customfieldRequest.fieldValue = this.getActualCurrencyValue(this.quickCallForm.value[customField.fieldId].data);
            } else {
              customfieldRequest.fieldValue = this.quickCallForm.value[customField.fieldId].data;
            }
            this.quickCallRequest.customFields.push(customfieldRequest);
          }
        }
        // creating Request
        if (this.quickCallTypeName === 'quickCall') {
          this.quickcallDetailService.createRequest(this.quickCallId, this.quickCallRequest).subscribe(
            (createdRequestResponse: CreatedRequestResponse) => {
              this.createdRequestResponse = createdRequestResponse;
              const alertMessage = new AlertMessage();
              alertMessage.type = 'info';
              alertMessage.message = 'Alert.requestCreated';
              // Hiding the Form, Changing the Modal Size and Displaying the Success Message content inside the same modal
              // This can be enhanced later

              alertMessage.params = this.createdRequestResponse.requestId.toString();
              this.incidentFileUpload.files = this.validFileList;
              this.incidentFileUpload.requestId = this.createdRequestResponse.requestId;
              if (this.validFileList.length > 0) {
                this.reportIncidentService.uploadAttachments(this.incidentFileUpload).subscribe(
                  (fileUploadStatus: FileUploadStatus) => {
                    this.loading = false;
                    if (fileUploadStatus.failureFiles && fileUploadStatus.failureFiles.length > 0) {
                      alertMessage.status = this.zsdTranslate.getTranslatedString('Alert', 'fileUploadfailure');
                      alertMessage.status += (fileUploadStatus.failureFiles.join(','));
                    }
                    this.alertService.displayAlert(alertMessage);
                    this.updateModalAfterRequestCreation();
                  },
                  err => {
                    this.loading = false;
                    if (err.error.localizedMessage) {
                      alertMessage.status = err.error.localizedMessage;
                    } else {
                      alertMessage.status = err.error.message;
                    }
                    this.alertService.displayAlert(alertMessage);
                    this.updateModalAfterRequestCreation();
                  });
              } else {
                this.alertService.displayAlert(alertMessage);
                this.updateModalAfterRequestCreation();
              }
            },
            err => {
              this.loading = false;
              this.serverError = 'Unable to connect to the server.';
              if (err.error.localizedMessage) {
                this.serverError = err.error.localizedMessage;
              } else if (err.error.message) {
                this.serverError = err.error.message;
              }
            }
          );
        }
      } else {
        if (this.itemSelectionRequired) {
          this.quickCallForm.controls['item'].markAsTouched();
        }
        if (this.subjectRequired) {
          this.quickCallForm.controls['subject'].markAsTouched();
        }
        (this.quickCallForm.controls['tinyMce'] as FormGroup).controls['tinymce'].markAsTouched();

        for (let i = 0; i < this.customFields.length; i++) {
          let fieldId = this.customFields[i].fieldId + '';
          (this.quickCallForm.controls[fieldId] as FormGroup).controls['data'].markAsTouched();
        }
      }
    } else {
      // flag to check validity of form
      let formValidFlag = true;
      if (this.quickCallDetail.groupComponentsSelection) {
        if (!(this.quickCallForm.controls['tinyMce'] as FormGroup).valid) {
          formValidFlag = false;
        }
        if (formValidFlag) {
          for (let i = 0; i < this.customFields.length; i++) {
            let fieldId = this.customFields[i].fieldId + '';
            if (!(this.quickCallForm.controls[fieldId] as FormGroup).valid) {
              formValidFlag = false;
              break;
            }
          }
        }
        if (formValidFlag) {
          if (!this.quickCallListForGroup.find(qc => qc.selected === true)) {
            formValidFlag = false;
            this.oneQuickcallSelected = true;
          } else {
            formValidFlag = true;
            this.oneQuickcallSelected = false;
          }
        }
        if (formValidFlag) {
          for (let i = 0; i < this.quickCallListForGroup.length; i++) {
            let quickcallId = this.quickCallListForGroup[i].id + '';
            if (this.quickCallListForGroup[i].selected && this.quickCallListForGroup[i].containCustom
              && !(this.quickCallForm.controls['qc' + quickcallId] as FormGroup).valid) {
              formValidFlag = false;
              break;
            }
          }
        }
      } else {
        formValidFlag = this.quickCallForm.valid;
      }
      // create group quick call service
      if (formValidFlag && this.fileUploadForm && this.checkForcustomformValidationForGroup()) {
        // description
        this.loading = true;
        this.groupQuickCallRequest.requestDescription = this.quickCallForm.value.tinyMce.tinymce;
        // custom fields
        for (let i = 0; i < this.customFields.length; i++) {
          let customField: CustomField = this.customFields[i];
          if (!this.groupQuickCallRequest.groupTemplateCustomFields) {
            this.groupQuickCallRequest.groupTemplateCustomFields = new Array<CustomFieldRequest>();
          }
          if (customField.clientEditable !== 0) {
            let customfieldRequest: CustomFieldRequest = new CustomFieldRequest();
            customfieldRequest.fieldId = customField.fieldId;
            if (customField.dataType === 4) { // Currency
              customfieldRequest.fieldValue = this.getActualCurrencyValue(this.quickCallForm.value[customField.fieldId].data);
            } else {
              customfieldRequest.fieldValue = this.quickCallForm.value[customField.fieldId].data;
            }
            this.groupQuickCallRequest.groupTemplateCustomFields.push(customfieldRequest);
          }
        }

        // quick Call List
        this.groupQuickCallRequest.groupTemplateQuickCalls = new Array<GroupTemplateQuickCallInfos>();
        for (let i = 0; i < this.quickCallListForGroup.length; i++) {
          if (!this.quickCallDetail.groupComponentsSelection ||
            (this.quickCallDetail.groupComponentsSelection && this.quickCallListForGroup[i].selected)) {
            let quickcall: GroupTemplateQuickCallInfos = new GroupTemplateQuickCallInfos();
            quickcall.quickCallId = this.quickCallListForGroup[i].id;
            if (this.quickCallListForGroup[i].containCustomForm) {
              let formData: string;
              if (this.quickCallForm.value['qc' + this.quickCallListForGroup[i].id].customform.formioform.hasOwnProperty('components')) {
                formData = this.getCustomFormData(this.quickCallForm.value['qc' +
                  this.quickCallListForGroup[i].id].customform.formioform);
              } else {
                formData = JSON.stringify(this.quickCallForm.value['qc' + this.quickCallListForGroup[i].id].customform.formioform);
              }
              quickcall.formData = formData;
            }
            if (this.quickCallListForGroup[i].containCustom) {
              for (let j = 0; j < this.quickCallListForGroup[i].customFieldInfo.length; j++) {
                let customField: CustomField = this.quickCallListForGroup[i].customFieldInfo[j];
                if (!quickcall.quickCallCustomFields) {
                  quickcall.quickCallCustomFields = new Array<CustomFieldRequest>();
                }
                if (customField.clientEditable !== 0) {
                  let customfieldRequest: CustomFieldRequest = new CustomFieldRequest();
                  customfieldRequest.fieldId = customField.fieldId;
                  if (customField.dataType === 4) { // Currency
                    customfieldRequest.fieldValue = this.getActualCurrencyValue(
                      this.quickCallForm.value['qc' + this.quickCallListForGroup[i].id][customField.fieldId].data);
                  } else {
                    customfieldRequest.fieldValue =
                      this.quickCallForm.value['qc' + this.quickCallListForGroup[i].id][customField.fieldId].data;
                  }
                  quickcall.quickCallCustomFields.push(customfieldRequest);
                }
              }
              this.groupQuickCallRequest.groupTemplateQuickCalls.push(quickcall);
            } else {
              quickcall.quickCallCustomFields = [];
              this.groupQuickCallRequest.groupTemplateQuickCalls.push(quickcall);
            }
          }
        }

        // calling request service for group quick call
        this.quickcallDetailService.createRequestFromGroupQuickcall(this.quickCallDetail.id, this.groupQuickCallRequest).subscribe(
          (requestNo: number[]) => {
            this.requestNumbers = requestNo;
            const alertMessage = new AlertMessage();
            alertMessage.type = 'info';
            alertMessage.message = 'Alert.requestsCreated';
            // Hiding the Form, Changing the Modal Size and Displaying the Success Message content inside the same modal
            // This can be enhanced later


            alertMessage.params = this.requestNumbers.join(', ');
            this.incidentFileUpload.files = this.validFileList;
            this.incidentFileUpload.requestId = this.requestNumbers[0];
            if (this.validFileList.length > 0) {
              this.reportIncidentService.uploadAttachmentsinGroup(this.incidentFileUpload).subscribe(
                () => {
                  this.loading = false;
                  this.alertService.displayAlert(alertMessage);
                  this.updateModalAfterRequestCreation();
                },
                err => {
                  this.loading = false;
                  alertMessage.message = alertMessage.message + err.error.localizedMessage;
                  this.alertService.displayAlert(alertMessage);
                  this.updateModalAfterRequestCreation();
                });
            } else {
              this.alertService.displayAlert(alertMessage);
              this.updateModalAfterRequestCreation();
            }

          },
          err => {
            this.loading = false;
            this.serverError = 'Unable to connect to the server.';
            if (err.error.localizedMessage) {
              this.serverError = err.error.localizedMessage;
            } else if (err.error.message) {
              this.serverError = err.error.message;
            }
          }
        );

      } else {
        (this.quickCallForm.controls['tinyMce'] as FormGroup).controls['tinymce'].markAsTouched();

        for (let i = 0; i < this.customFields.length; i++) {
          let fieldId = this.customFields[i].fieldId + '';
          (this.quickCallForm.controls[fieldId] as FormGroup).controls['data'].markAsTouched();
        }

        for (let i = 0; i < this.quickCallListForGroup.length; i++) {
          $('#table_body' + this.quickCallListForGroup[i].id).css('border', 'none');
          let quickcallId = this.quickCallListForGroup[i].id + '';
          if (this.quickCallDetail.groupComponentsSelection) {
            if (this.quickCallListForGroup[i].containCustom) {
              for (let j = 0; j < this.quickCallListForGroup[i].customFieldInfo.length; j++) {
                let fieldId = this.quickCallListForGroup[i].customFieldInfo[j].fieldId + '';
                ((this.quickCallForm.controls['qc' + quickcallId] as FormGroup)
                  .controls[fieldId] as FormGroup).controls['data'].markAsUntouched();
              }
            }
            if (!this.quickCallListForGroup.find(qc => qc.selected === true)) {
              this.oneQuickcallSelected = true;
            } else {
              this.oneQuickcallSelected = false;
            }
          }

          if (!this.quickCallDetail.groupComponentsSelection ||
            (this.quickCallDetail.groupComponentsSelection && this.quickCallListForGroup[i].selected)) {
            if (this.quickCallListForGroup[i].containCustom) {
              for (let j = 0; j < this.quickCallListForGroup[i].customFieldInfo.length; j++) {
                let fieldId = this.quickCallListForGroup[i].customFieldInfo[j].fieldId + '';
                ((this.quickCallForm.controls['qc' + quickcallId] as FormGroup)
                  .controls[fieldId] as FormGroup).controls['data'].markAsTouched();
              }
            }
            if (this.quickCallListForGroup[i].containCustomForm || this.quickCallListForGroup[i].containCustom) {
              if (!(this.quickCallForm.controls['qc' + quickcallId] as FormGroup).valid ||
                (this.quickCallListForGroup[i].containCustomForm &&
                  !(((this.quickCallForm.controls['qc' + quickcallId] as FormGroup)
                    .controls['customform'] as FormGroup).controls['formiovalid'].value))) {
                $('#table_body' + this.quickCallListForGroup[i].id).css('border', '3px solid rgba(255,0,0,0.3)');
              } else {
                $('#table_body' + this.quickCallListForGroup[i].id).css('border', 'none');
              }
            }
          }
        }
      }
    }
  }
  selectQuickCall(quickCall: QuickCallDetailInfo, $event: any) {
    $event.stopPropagation();
    quickCall.selected = !quickCall.selected;
  }

  getActualCurrencyValue(formattedCurrencyValue) {
    if (formattedCurrencyValue) {
      formattedCurrencyValue = formattedCurrencyValue.replace(/[^\d\.\-eE+]/g, '');
      formattedCurrencyValue = formattedCurrencyValue ? parseFloat(formattedCurrencyValue) : 0;
      formattedCurrencyValue = !formattedCurrencyValue ? 0 : formattedCurrencyValue;
    }
    return formattedCurrencyValue;
  }

  showProposedSolutionPage(requestId: number): string {
    return '/proposedsolution/' + requestId;
  }

  getCustomFormData(data) {
    let submitData = {};
    data.components.forEach(component => {
      if (component.key === 'submit') {
        let key = component.key;
        let value = true;
        submitData[key] = value;
      } else {
        let key = component.key;
        let value;
        if (component.defaultValue == null) {
          value = '';
        } else {
          value = component.defaultValue;
        }
        submitData[key] = value;
      }
    });
    return JSON.stringify(submitData);
  }

  updateModalAfterRequestCreation() {
    $('#quick_call_row').hide();
    if ($(window).width() < 991) {
      $('#zsd_modal_quickcall_detail').css('width', '80%');
      $('#zsd_modal_quickcall_detail').css('margin-left', '8%');
    } else {
      $('#zsd_modal_quickcall_detail').css('width', '40%');
      $('#zsd_modal_quickcall_detail').css('margin-left', '30%');
    }

    $('#zsd_modal_quickcall_detail .modal-header').css('display', 'none');
    $('#zsd_modal_quickcall_detail .modal-header').hide();
    $('#request_success_msg').show();
  }

  onClick(i: number) {
    if ($('#qc_custom_field' + i).hasClass('expand collapsed')) {
      $('#plusicon' + i).removeClass('fa fa-plus-square fa-lg');
      $('#plusicon' + i).addClass('fa fa-minus-square fa-lg');
      $('#qc_custom_field' + i).addClass('highlight_row');
    } else {
      $('#plusicon' + i).removeClass('fa fa-minus-square fa-lg');
      $('#plusicon' + i).addClass('fa fa-plus-square fa-lg');
      $('#qc_custom_field' + i).removeClass('highlight_row');
    }
  }

  currentSearchItemIndex = -1;

  itemSearchListKeyPressAction(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode === 40) { // Key Down action
      event.preventDefault();
      this.currentSearchItemIndex++;
      if (this.currentSearchItemIndex >= this.itemResultFromSearch.length) {
        this.currentSearchItemIndex = 0;
      }
      let listid = `searchitem${this.currentSearchItemIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 38) { // Key up action
      event.preventDefault();
      this.currentSearchItemIndex--;
      if (this.currentSearchItemIndex < 0) {
        this.currentSearchItemIndex = (this.itemResultFromSearch.length - 1);
      }
      let listid = `searchitem${this.currentSearchItemIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 13) { // Enter action
      event.preventDefault();
      document.getElementById('searchitem' + this.currentSearchItemIndex).click();
    } else {
      this.currentSearchItemIndex = -1;
    }

    return true;
  }

}
